import { Request } from '@group-devs/yfp7-global-modules'
import { Media } from 'react-bootstrap'
import Link from 'next/link'

const request = new Request(process.env.apiDomain)

function EOTour(props) {
    const site = props.site
    const { data: eo } = request.website.swrSite(site.accountId, "EO")

    return (
        <div className="d-md-flex justify-content-between align-items-center my-5 py-3 mx-lg-5 px-lg-5">
            <Media>
                <img width={100} src="../images/dashboard/img-take-the-tour01.svg" alt="Explore the Opportunity" className="img-fluid mr-3"/>
                <Media.Body className="d-md-flex justify-content-between align-items-center ">
                    <div>
                        <h5 className="h6"><strong>Explore the Opportunity</strong></h5>
                        <p className="h7 w-75">
                            Learn how to create an excellent side income and a better lifestyle
                            by guiding people through websites like this using your laptop,
                            smart phone and social media. 
                        </p>
                    </div>
                    { eo ? <a href={ '//' + eo.url + '/tour' } className="px-4 py-2 btn-blue text-uppercase text-white h7 btn-tour text-center">Start Tour</a> : null }
                </Media.Body>
            </Media>
            
            <style jsx>{`
                .btn-tour{
                    width:208px;
                }
                @media(max-width:1199px){
                    .btn-tour{
                        width:267px;
                    }
                }
                @media(max-width:991px){
                    .btn-tour{
                        width:292px;
                    }
                }
            `}</style>
        </div>
    )
}

export default EOTour
